import * as XLSX from "xlsx";
import { Logger, baseContainer } from "@base-provider";
// core imports
import { getFullDateISO } from "../../services/dateService";
// import { createAjv } from "@jsonforms/core";
// import { COLUMN_MAPPING_STATUS_ACTION, COLUMN_MAPPING_STATUS } from "../constants/columnMappingStatus";

export default class FileUploadHandler {
  constructor() {
    /** File placeholder */
    this.file = null;
    /** @type {Array} Converted file data in array format*/
    this.fileData = null;
    //todo: move to redux
    /** @type {Array} Converted file data 10 first rows in array format*/
    this.mappedPreviewData = [];
    // this.validator = createAjv();
    this.sheetCount = null;
    this.schema = null;
  }

  clearFile() {
    this.file = null;
    this.fileData = null;
    this.sheetCount = null;
    this.schema = null;
  }

  async setFile(file, schema) {
    this.file = file;
    this.schema = schema;
    this.fileData = await this.#convertFile();
  }
  /**
   * Parse a file and retrieve data in array format
   * @returns {Promise}
   */
  #convertFile = async () => {
    let _this = this;
    let schema = _this.schema;
    return new Promise((resolve, reject) => {
      if (this.file) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(this.file);
        reader.onload = function (e) {
          var data = new Uint8Array(reader.result);
          var workbook = XLSX.read(data, {
            type: "array",
            cellDates: true,
            dateNF: "yyyy-MM-dd",
          });
          _this.sheetCount = workbook.SheetNames.length;
          var sheet = workbook.Sheets[workbook.SheetNames[0]];
          var json = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false });
          json.forEach((row) => {
            Object.entries(row).forEach(([key, value]) => {
              const type = schema.properties[key]?.type;
              const schemaHasString = Array.isArray(type)
                ? type.includes("string")
                : type === "string";
              //check if row value is a date (number of days) so we can format it to full date iso
              if (typeof value.getMonth === "function") {
                let formattedDate = getFullDateISO(value);
                row[key] = formattedDate.toString();
              } else if (typeof value !== "string" && schemaHasString) {
                row[key] = value.toString();
              }
            });
          });
          Logger.of("App.Core.FileUploader.convertFile.onload").info({
            json,
          });
          resolve(json);
        };
      } else {
        resolve([]);
      }
    });
  };

  //todo: move to redux
  getFileSizeString() {
    if (!this.file) {
      return null;
    }

    let sizes = ["B", "KB", "MB", "GB"];

    let index = Math.floor(Math.log(this.file.size) / Math.log(1024));

    return `${parseFloat(this.file.size / Math.pow(1024, index)).toFixed(2)} ${
      sizes[index]
    }`;
  }

  getFileName() {
    if (!this.file) {
      return null;
    }

    return this.file.name;
  }

  getFilePreview(resultData) {
    let tenRows = this.fileData?.slice(0, 10) ?? [];
    let mappedColumns = resultData.filter((x) => x.action === 0);
    let cols = mappedColumns.map((cl) => cl.dest);

    let previewData = [];
    for (let i = 0; i < tenRows.length; i++) {
      let obj = {};
      for (let j = 0; j < mappedColumns.length; j++) {
        obj[cols[j]] = tenRows[i][mappedColumns[j].src]?.toString();
      }
      previewData.push(obj);
    }
    return previewData;
  }

  getTenantId() {
    var tenantId = null;
    //if the env variable exists and is set to true
    //then get the tenant id from the base container(local storage)
    //else return null which will translate to an empty guid as the tenantid
    if (!process.env.REACT_APP_WEB_ADMIN) {
      tenantId = baseContainer.authenticationService.getSelectedTenant();
    }
    return tenantId;
  }
}
